import axios from '../../../../utils/AxiosUtils';
import i18n from '../../../../i18next';
import {
    LOADING,
    LOAD_ORDER_TYPE_MAPPINGS_SUCCESS,
    UPDATE_ORDER_TYPE_MAPPINGS_SUCCESS,
    CLEAR_ORDER_TYPE_MAPPINGS,
    LOAD_POS_ORDER_TYPES_SUCCESS,
    IMPORT_POS_ORDER_TYPES_SUCCESS
} from '../../../types';
import MessageUtils from '../../../../utils/MessageUtils';

export const loadOrderTypeMappings = (restaurantId) => {
    return (dispatch) => {

        if (restaurantId !== undefined && restaurantId !== null && Number(restaurantId) !== -1) {
            dispatch({ type: LOADING, payload: true });

            const url = `/restaurant/${restaurantId}/order-type-mappings`;

            axios().get(url)
                .then(response => loadOrderTypeMappingsSuccess(dispatch, response.data))
                .catch(error => MessageUtils.errorMessageResponse(
                    dispatch, error.response.data, i18n.t('actions:orderTypeMapping.loadOrderTypeFailure')));
        }
    }
}

const loadOrderTypeMappingsSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_ORDER_TYPE_MAPPINGS_SUCCESS, payload: response });
}

export const loadPosOrderTypes = (restaurantId) => {
    return (dispatch) => {

        if (restaurantId !== undefined && restaurantId !== null && Number(restaurantId) !== -1) {
            dispatch({ type: LOADING, payload: true });

            const url = `/restaurant/${restaurantId}/pos-order-types`;

            axios().get(url)
                .then(response => loadPosOrderTypesSuccess(dispatch, response))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:orderTypeMapping.loadPosOrderTypeFailure')));
        }
    }
}

const loadPosOrderTypesSuccess = (dispatch, response, isImport) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_POS_ORDER_TYPES_SUCCESS, payload: response.data });

    if (isImport !== undefined && isImport === true) {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:orderTypeMapping.importPosOrderTypeSuccess'));
    }
}

export const updateOrderTypeMappings = (state, restaurantId) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/order-type-mappings`;
        const orderTypeMappings = [];

        state.map(currentMapping => {
            if (currentMapping.posOrderType.id == -1) {
                const sanitizedMapping = {
                    id: currentMapping.id,
                    orderType: {
                        id: currentMapping.orderType.id,
                        value: currentMapping.orderType.value
                    },
                    posOrderType: null
                }
                orderTypeMappings.push(sanitizedMapping);

            } else {
                orderTypeMappings.push(currentMapping);
            }
        });

        axios().put(url, orderTypeMappings)
            .then(response => updateOrderTypeMappingsSuccess(dispatch, getState, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.saveFailure')));
    }
}

const updateOrderTypeMappingsSuccess = (dispatch, response) => {
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.saveSuccess'));
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: UPDATE_ORDER_TYPE_MAPPINGS_SUCCESS, payload: response });
}

export const clearOrderTypeMappings = (dispatch) => {
    return (dispatch) => {
        dispatch({ type: CLEAR_ORDER_TYPE_MAPPINGS });
    }
}

export const importPosOrderTypes = (restaurantId) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/import-pos-order-types`;

        axios().get(url)
            .then(response => importPosOrderTypesSuccess(dispatch, response, restaurantId))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:orderTypeMapping.importPosFailure')));
    }
}

const importPosOrderTypesSuccess = (dispatch, response, restaurantId) => {
    dispatch({ type: IMPORT_POS_ORDER_TYPES_SUCCESS, payload: response });

    const url = `/restaurant/${restaurantId}/pos-order-types`;

    axios().get(url)
        .then(response => loadPosOrderTypesSuccess(dispatch, response, true))
        .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:orderTypeMapping.loadPosOrderTypeFailure')));
}



// WEBPACK FOOTER //
// ./src/actions/restaurants/settings/pos/OrderTypeMappingAction.js